
.root {
    flex: 1;
    padding: 0.5cm;
}
